import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "sticky-cta"
};
const _hoisted_2 = { class: "container d-flex justify-content-between align-items-center" };
const _hoisted_3 = { class: "hotel-name" };
const _hoisted_4 = { class: "d-flex align-items-center gap-2" };
const _hoisted_5 = {
    key: 0,
    class: "price"
};
const _hoisted_6 = ["href"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'StickyCTA',
    props: {
        title: {},
        price: {},
        phoneOrWhatsapp: {},
        show: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const whatsAppUrl = computed(() => {
            const phone = (props.phoneOrWhatsapp || '').replace(/[^\d+]/g, '');
            const msg = encodeURIComponent(`Hola, me interesa ${props.title}.`);
            return phone ? `https://wa.me/${phone}?text=${msg}` : `https://wa.me/?text=${msg}`;
        });
        const show = computed(() => props.show !== false);
        return (_ctx, _cache) => {
            return (show.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("strong", _hoisted_3, _toDisplayString(__props.title), 1),
                        _createElementVNode("div", _hoisted_4, [
                            (__props.price)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.price), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("a", {
                                href: whatsAppUrl.value,
                                target: "_blank",
                                rel: "noopener",
                                class: "btn btn-outline-success btn-sm btn-cta"
                            }, [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("i", { class: "fab fa-whatsapp me-1 icon-small" }, null, -1),
                                    _createTextVNode("Contactar ", -1)
                                ]))], 8, _hoisted_6),
                            _cache[1] || (_cache[1] = _createElementVNode("button", { class: "btn btn-primary btn-sm btn-cta" }, "Reservar", -1))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
